import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

const defaultUserProfile = {
  height: null,
  weight: null,
  complexion: null,
  bodyType: null,
  disability: null
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.profile.info;
  //get all static data
  const { data } = state;
  //if any of the static data is empty return the default value
  if (
    isEmpty(data.height) ||
    isEmpty(data.complexion) ||
    isEmpty(data.bodyType) ||
    isEmpty(data.disability)
  ) {
    return defaultUserProfile;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return defaultUserProfile;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(userProfile, (value, key) => {
      if (key === "height") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "weight") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          object[key] = { label: `${value} Kg`, value };
        }
      } else if (key === "complexion") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "bodyType") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "disability") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else {
        //do nothing
      }
    });
    return object;
  } catch (error) {
    return defaultUserProfile;
  }
};
//VERIFY IF THE JWT IS SET
const getMemberPhysicalProfile = createSelector(
  getData,
  userProfile => userProfile
);
export default getMemberPhysicalProfile;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberPhysicalProfile.js